export const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9osvo8senbniolesla0';